<template>
   <div>
    <div class="c"></div>
    <div id="bd" style="margin-bottom:50px;">
    <div class="cur">
        <div class="wp"> 您的当前位置：
            <router-link to="/"><a href="javascript:;" @click="menu_change(0)" tppabs="http://www.861ppt.com/122">主页</a></router-link> 
            >
            <router-link to="xwdt"><a href="javascript:;" tppabs="http://www.861ppt.com/122/a/zhishiboke/">新闻动态</a></router-link>
            >
            <a href="javascript:;" >新闻详情</a>
        </div>
    </div>
    <div class="wp case-article">
        <div class="article">
            <!-- <h1>{{title}}<div v-if="stick == '1'" class="top">置顶</div></h1>
            
            <p class="time">时间：{{creatTime}}</p> -->
            <div class="article-con ql-editor" style="margin:0 auto;line-height:2.4;width:60%;" v-html="content"></div>
            <div class="h20"></div>
            <router-link to="xwdt">
                <div class="case-back "><a href="javascript:;">返回新闻列表</a></div>
            </router-link>
            
            <!-- <div class="share"> <span>分享到：</span>
                <div class="bdsharebuttonbox"><a href="#" class="bds_more" data-cmd="more"></a><a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间"></a><a href="#" class="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a><a href="#" class="bds_tqq" data-cmd="tqq" title="分享到腾讯微博"></a>
                    <a
                        href="#" class="bds_renren" data-cmd="renren" title="分享到人人网"></a><a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信"></a></div>
                <script>
                    window._bd_share_config = {
                        "common": {
                            "bdSnsKey": {},
                            "bdText": "",
                            "bdMini": "2",
                            "bdMiniList": false,
                            "bdPic": "",
                            "bdStyle": "0",
                            "bdSize": "24"
                        },
                        "share": {},
                        "selectShare": {
                            "bdContainerClass": null,
                            "bdSelectMiniList": ["qzone", "tsina", "tqq", "renren", "weixin"]
                        }
                    };
                    with(document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)];
                </script>
            </div> -->
        </div>
    </div>
</div>
    <!-- end #bd -->
</div>
</template>
<style>
.top{
    display: inline;
    padding: 3px 6px;
}
</style>

<script>
import '../assets/css/quill.core.css';
export default {
    data(){
        return {
            title:'',
            creatTime:'',
            stick:'',//置顶标志
            synopsis:'',//简介
            content:''

        }
    },
    mounted(){
        console.log(this.$route.query)
        // if(this.$route.params.news_detail){
        //     this.title = this.$route.params.news_detailtitle;
        //     this.creatTime = this.$route.params.news_detail.createtime;
        //     this.stick =  this.$route.params.news_detail.stick;
        //     this.synopsis =  this.$route.params.news_detail.synopsis;
        //     this.content = this.$route.params.news_detail.content;
        // }else{
        //     console.log('meiyou ')
        // }
        //if(this.$route.query.id != null){
            this.$get("/api/website/xzsoft/website/xwdt/getNewsDetail",{id:this.$route.query.id}).then((response) => {
                //console.log("=====新闻类型")
                //console.log(response)
                this.title = response.data.title;
                this.creatTime =  response.data.createtime;
                this.stick =  response.data.stick;
                this.synopsis =  response.data.synopsis;
                this.content = response.data.content;
            }).catch(function(error) {
                //console.error("=====新闻类型请求错误")
                console.log(error,)
            })
        //}else{
           //this.$router.push('xwdt')
        //}
        
    },
    methods:{
        menu_change(index){
            this.$store.dispatch('getNavbar',index) 
            //this.flag = index;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/news_detail.vue